/* @jsx jsx */
import { jsx } from "theme-ui";
import { Global, css } from "@emotion/core";
import theme from "../gatsby-plugin-theme-ui";

export default () => (
  <Global
    // @ts-ignore
    styles={css`
      code[class*="language-"],
      pre[class*="language-"] {
        text-align: left;
        white-space: pre;
        word-spacing: normal;
        word-break: normal;
        word-wrap: normal;
        color: #46575f;
        background: ${theme.colors.gray[1]};
        font-family: "SFMono-Regular", Menlo, Monaco, Consolas,
          "Liberation Mono", "Courier New", monospac;
        line-height: 1.5em;

        -moz-tab-size: 4;
        -o-tab-size: 4;
        tab-size: 4;

        -webkit-hyphens: none;
        -moz-hyphens: none;
        -ms-hyphens: none;
        hyphens: none;
      }

      code[class*="language-"]::-moz-selection,
      pre[class*="language-"]::-moz-selection,
      code[class*="language-"] ::-moz-selection,
      pre[class*="language-"] ::-moz-selection {
        background: #cceae7;
        color: #263238;
      }

      code[class*="language-"]::selection,
      pre[class*="language-"]::selection,
      code[class*="language-"] ::selection,
      pre[class*="language-"] ::selection {
        background: #cceae7;
        color: #263238;
      }

      :not(pre) > code[class*="language-"] {
        white-space: normal;
        border-radius: 0.2em;
        padding: 0.1em;
      }

      pre[class*="language-"] {
        overflow: auto;
        position: relative;
        margin: 0.5em 0;
        padding: 1.25em 1em;
      }

      .language-css > code,
      .language-sass > code,
      .language-scss > code {
        color: #f76d47;
      }

      [class*="language-"] .namespace {
        opacity: 0.7;
      }

      .token.atrule {
        color: ${theme.colors.purple[7]};
      }

      .token.attr-name {
        color: ${theme.colors.teal[6]};
      }

      .token.attr-value {
        color: ${theme.colors.brandOrange[3]};
      }

      .token.attribute {
        color: ${theme.colors.brandOrange[3]};
      }

      .token.boolean {
        color: ${theme.colors.purple[7]};
      }

      .token.builtin {
        color: #39adb5;
      }

      .token.cdata {
        color: #39adb5;
      }

      .token.char {
        color: #39adb5;
      }

      .token.class {
        color: #39adb5;
      }

      .token.class-name {
        color: #6182b8;
      }

      .token.comment {
        color: #8ba8b5;
      }

      .token.constant {
        color: ${theme.colors.purple[7]};
      }

      .token.deleted {
        color: ${theme.colors.brandOrange[4]};
      }

      .token.doctype {
        color: #8ba8b5;
      }

      .token.entity {
        color: ${theme.colors.brandOrange[4]};
      }

      .token.function {
        color: ${theme.colors.purple[7]};
      }

      .token.hexcode {
        color: #f76d47;
      }

      .token.id {
        color: ${theme.colors.purple[7]};
        font-weight: bold;
      }

      .token.important {
        color: ${theme.colors.purple[7]};
        font-weight: bold;
      }

      .token.inserted {
        color: #39adb5;
      }

      .token.keyword {
        color: ${theme.colors.purple[7]};
      }

      .token.number {
        color: #f76d47;
      }

      .token.operator {
        color: #39adb5;
      }

      .token.prolog {
        color: #8ba8b5;
      }

      .token.property {
        color: #39adb5;
      }

      .token.pseudo-class {
        color: ${theme.colors.brandOrange[3]};
      }

      .token.pseudo-element {
        color: ${theme.colors.brandOrange[3]};
      }

      .token.punctuation {
        color: #39adb5;
      }

      .token.regex {
        color: #6182b8;
      }

      .token.selector {
        color: ${theme.colors.brandOrange[4]};
      }

      .token.string {
        color: ${theme.colors.brandOrange[3]};
      }

      .token.symbol {
        color: ${theme.colors.purple[7]};
      }

      .token.tag {
        color: ${theme.colors.brandOrange[4]};
      }

      .token.unit {
        color: #f76d47;
      }

      .token.url {
        color: ${theme.colors.brandOrange[4]};
      }

      .token.variable {
        color: ${theme.colors.brandOrange[4]};
      }
    `}
  />
);
